<template>
  <div class="pdf-show">
    <div class="left">
      <div class="left-header">
        <div class="header-left">
          <el-link :underline="false">请仔细完善在线简历</el-link>
        </div>
        <div class="header-right">
          <el-button type="info" @click="close">取消</el-button>
          <el-button type="primary" @click="recomReport">保存</el-button>
        </div>
      </div>
      <div class="left-container">
        <div class="uploadFile">
          <div v-if="resumeList == null">
            <el-upload class="upload-demo" :show-file-list="false" :multiple="false" drag this.post.userName
              :action="uploadUrl" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <div>将文件拖到此处，或<em>点击上传</em></div>
                <div>支持20M以内的doc, docx, pdf, jpg, jpeg, png文件</div>
              </div>
            </el-upload>
          </div>
          <!-- 显示上传成功的文件名 -->
          <div v-if="uploadedFileName !== null" class="uploaded-file-info">
            <span class="el-icon-check"></span>
            <span>已上传 </span>
            <span v-loading="loading">{{ uploadedFileName }}</span>
            <el-button type="text" size="mini" @click="clearUploadedFile" v-if="loading === false" class="ml-2">
              移除
            </el-button>
          </div>
        </div>
        <div class="report">
          <div class="report-title">基本信息</div>
          <div class="Basic-information">
            <div class="Basic-des-left">
              <div class="des-input">
                <span class="import">姓名：</span>
                <el-input size="small" placeholder="请输入候选人姓名" v-model="post.name" clearable>
                </el-input>
              </div>
              <div class="des-input">
                <span class="import">手机：</span>
                <el-input size="small" placeholder="请输入手机号码" v-model="post.phone" clearable>
                </el-input>
              </div>
              <div class="des-input">
                <span>微信：</span>
                <el-input size="small" placeholder="请输入微信号码" v-model="post2.wechat" clearable>
                </el-input>

              </div>
              <div class="des-input">
                <span class="import">求职状态：</span>
                <el-select size="small" v-model="post.jobStatu" clearable placeholder="请选择求职状态">
                  <el-option v-for="item in jobStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="des-input">
                <span class="import">工作年限：</span>
                <el-select size="small" v-model="post.workYear" clearable placeholder="请选择工作年限">
                  <el-option v-for="item in workYearList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="Basic-des-right">
              <div class="left-des">
                <span class="import">性别：</span>
                <el-select size="small" v-model="post.gender" clearable placeholder="请选择最高学历">
                  <el-option v-for="item in genders" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="left-des">
                <span>邮箱：</span>
                <el-input size="small" placeholder="请输入邮箱地址" v-model="post2.email" clearable>
                </el-input>
              </div>
              <div class="left-des">
                <span class="import">最高学历：</span>
                <el-select size="small" v-model="post.highestEdu" clearable placeholder="请选择最高学历">
                  <el-option v-for="item in highestEdus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="left-des">
                <span class="import">出生年份：</span>
                <el-date-picker size="small" v-model="post.birthYear" type="year" placeholder="选择出生年份" format="yyyy 年"
                  @change="YearDateChange">
                </el-date-picker>
              </div>
              <div class="left-des">
                <span>人才标签：</span>
                <el-select size="small" v-model="post2.label" clearable placeholder="请选择人才标签">
                  <el-option v-for="item in labels" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title">求职意向</div>
          <div class="want-information">
            <div class="des-input">
              <span class="import">期望城市：</span>
              <el-cascader size="small" placeholder="请选择现居地址" v-model="post.wantCity" :options="hjCityList"
                :show-all-levels="false" filterable></el-cascader>
            </div>
            <div class="des-input">
              <span class="import">期望薪资：</span>
              <div class="salary">
                <el-input size="small" placeholder="请输入期望薪资" maxlength="4" v-model="post.wantSalary">
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title education-title">
            <div>教育经历</div>
            <div class="add-education">
              <i class="el-icon-circle-plus" @click="addEducation"> 添加教育经历</i>
            </div>
          </div>
          <div class="Education-experience" v-for="(item, i) in educationList" :key="i">
            <div class="Education-des">
              <div class="des-input">
                <span>学校：</span>
                <el-input size="small" placeholder="请输入学校名称" v-model="item.schoolName" clearable>
                </el-input>
              </div>
              <div class="des-input" style="margin-left: 20px;">
                <span>日期：</span>
                <div class="Education-date">
                  <div class="Education-date-des" style="border: 1px solid #DCDFE6;border-radius: 4px;width:210px;">
                    <el-date-picker size="small" v-model="item.eduStart" type="month" placeholder="开始年月"
                      @change="changeEdu(i, 'Strat')">
                    </el-date-picker>
                    <i>至</i>
                    <el-date-picker size="small" v-model="item.eduEnd" type="month" placeholder="结束年月"
                      :disabled="item.schoolEndNegotiable" @change="changeEdu(i, 'End')">
                    </el-date-picker>
                  </div>
                  <el-checkbox size="small" v-model="item.schoolEndNegotiable" style="margin-left: 20px;"
                    @change="setZJ(i, 'education')">至今</el-checkbox>
                </div>
              </div>
            </div>
            <div class="Education-des">
              <div class="des-input">
                <span>学历：</span>
                <el-select size="small" v-model="item.edu" clearable placeholder="请选择学历">
                  <el-option v-for="item in edus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <div style="margin-left:20px">
                  <el-radio size="small" v-model="item.isUnified" label="统招">统招</el-radio>
                  <el-radio size="small" v-model="item.isUnified" label="非统招">非统招</el-radio>
                </div>
              </div>
            </div>
            <div class="Education-des">
              <div class="des-input">
                <span>专业：</span>
                <el-input size="small" placeholder="请输入专业名称" v-model="item.major" clearable>
                </el-input>
                <el-tooltip class="item" effect="dark" content="删除教育经历" placement="top">
                  <i class="el-icon-delete" style="margin-left:20px;cursor: pointer;" @click="DelEdu(i)"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title work-title">
            <div>工作经历</div>
            <div class="add-job">
              <i class="el-icon-circle-plus" @click="addWork"> 添加工作经历</i>
            </div>
          </div>
          <div class="Work-experience" v-for="(item, i) in workList" :key="i">
            <div class="Work-des">
              <div class="des-input">
                <span>日期：</span>
                <div class="Work-date">
                  <div class="Work-date-des" style="border: 1px solid #DCDFE6;border-radius: 4px;width:210px;">
                    <el-date-picker v-model="item.workStart" type="month" placeholder="开始年月"
                      @change="changeWork(i, 'Strat')">
                    </el-date-picker>
                    <i>至</i>
                    <el-date-picker v-model="item.workEnd" type="month" placeholder="结束年月"
                      :disabled="item.workEndNegotiable" @change="changeWork(i, 'End')">
                    </el-date-picker>
                  </div>
                  <el-checkbox v-model="item.workEndNegotiable" style="margin-left: 20px;"
                    @change="setZJ(i, 'work')">至今</el-checkbox>

                </div>
                <el-tooltip class="item" effect="dark" content="删除工作经历" placement="top">
                  <i class="el-icon-delete" style="margin-left:30px;cursor: pointer;" @click="DelWork(i)"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="Work-des">
              <div class="Work-des-content">
                <div class="des-input">
                  <span>公司：</span>
                  <el-input placeholder="请输入公司名称" v-model="item.companyName" clearable>
                  </el-input>
                </div>
                <div class="des-input">
                  <span>职位：</span>
                  <el-input placeholder="请输入任职职位" v-model="item.jobName" clearable>
                  </el-input>
                </div>
              </div>
            </div>
            <div class="Work-vertical">
              <span>工作关系：</span>
              <div class="des-input">
                <el-input placeholder="所在部门" v-model="item.department" clearable>
                </el-input>
                <el-input placeholder="汇报对象" v-model="item.reportPeople" clearable>
                </el-input>
                <el-input placeholder="管理人数" v-model="item.underPeople" clearable>
                </el-input>
              </div>
            </div>
            <div class="Work-vertical">
              <span>工作职责：</span>
              <el-input type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入工作职责" v-model="item.workContent">
              </el-input>
            </div>
            <div class="Work-vertical">
              <span>工作业绩：</span>
              <el-input type="textarea" :autosize="{ minRows: 1 }" placeholder="请输入工作业绩" v-model="item.workAchievement">
              </el-input>
            </div>
            <div class="Work-vertical" v-if="item.workEnd == '9999.0' || item.workEnd == '至今'">
              <span>求职动机：</span>
              <el-input type="textarea" :autosize="{ minRows: 1 }" placeholder="请输入求职动机" v-model="item.dimissionReason">
              </el-input>
            </div>
            <div class="Work-vertical" v-else>
              <span>离职原因：</span>
              <el-input type="textarea" :autosize="{ minRows: 1 }" placeholder="请输入离职原因" v-model="item.dimissionReason">
              </el-input>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title project-title">
            <div>项目经历</div>
            <div class="add-project">
              <i class="el-icon-circle-plus" @click="addProject"> 添加项目经历</i>
            </div>
          </div>
          <div class="project-experience" v-for="(item, i) in projectList" :key="i">
            <div class="project-des">
              <div class="des-input">
                <span>日期：</span>
                <div class="project-date">
                  <div class="project-date-des" style="border: 1px solid #DCDFE6;border-radius: 4px;width:210px;">
                    <el-date-picker v-model="item.projectStart" type="month" placeholder="开始年月"
                      @change="changeProject(i, 'Strat')">
                    </el-date-picker>
                    <i>至</i>
                    <el-date-picker v-model="item.projectEnd" type="month" placeholder="结束年月"
                      :disabled="item.projectEndNegotiable" @change="changeProject(i, 'End')">
                    </el-date-picker>
                  </div>
                  <el-checkbox v-model="item.projectEndNegotiable" style="margin-left: 20px;"
                    @change="setZJ(i, 'project')">至今</el-checkbox>
                </div>
                <el-tooltip class="item" effect="dark" content="删除项目经历" placement="top">
                  <i class="el-icon-delete" style="margin-left:30px;cursor: pointer;" @click="DelPro(i)"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="project-des">
              <div class="project-des-content">
                <div class="des-input">
                  <span style="margin-right:10px">项目名称：</span>
                  <el-input placeholder="请输入项目名称" v-model="item.projectName" clearable>
                  </el-input>
                </div>
              </div>
            </div>
            <div class="project-vertical">
              <span>项目描述：</span>
              <el-input type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入项目描述" v-model="item.projectDesc">
              </el-input>
            </div>
            <div class="project-vertical">
              <span>项目职责：</span>
              <el-input type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入项目职责"
                v-model="item.projectResponsibility">
              </el-input>
            </div>
            <div class="project-vertical">
              <span>项目业绩：</span>
              <el-input type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入项目业绩"
                v-model="item.projectPerformance">
              </el-input>
            </div>
          </div>
        </div>
        <div class="report">
          <div class="report-title">自我介绍</div>
          <div class="myself-information">
            <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 8 }" placeholder="请输入自我介绍"
              v-model="post2.myself">
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="look">
        <PdfViewer :pdfUrl="fileUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import PdfViewer from '@/components/resume/pdfShow'
import { AddResume } from '@/request/api'
export default {
  components: {
    PdfViewer
  },
  created() {
    this.uploadUrl = 'https://spapi.wearehpr.cn/admin/resGetInfo?username=' + JSON.parse(sessionStorage.getItem("LoginInfo")).username
  },
  data() {
    return {
      post: {
        name: '', //候选人姓名
        phone: '', // 手机号
        gender: '', //性别
        birthYear: '', // 出生日期
        workYear: '', // 工作年限
        wantCity: '', // 期望城市
        wantSalary: '', // 期望薪资
        highestEdu: '', // 最高学历
        jobStatu: '',// 工作状态
      },
      post2: {
        wechat: '', // 微信
        email: '', // 邮箱
        label: '', // 人才标签
        myself: '' // 自我介绍
      },
      uploadUrl: '',
      resumeList: null,
      uploadedFileName: null,
      loading: false,
      genders: [{
        value: 1,
        label: '男'
      }, {
        value: 0,
        label: '女'
      }],
      labels: [{
        value: 1,
        label: '战略匹配型(超出预期)'
      }, {
        value: 2,
        label: '胜任匹配型(符合要求)'
      }, {
        value: 3,
        label: '发展适配型(具备潜力)'
      }, {
        value: 4,
        label: '暂不匹配型(不太符合)'
      }],
      jobStatus: [
        {
          value: 1,
          label: '离职-随时到岗'
        },
        {
          value: 2,
          label: '在职-暂不考虑'
        },
        {
          value: 3,
          label: '在职-考虑机会'
        },
        {
          value: 4,
          label: '在职-月内到岗'
        }
      ],
      highestEdus: [
        {
          value: 1,
          label: '大专以下'
        },
        {
          value: 2,
          label: '大专'
        },
        {
          value: 3,
          label: '本科'
        },
        {
          value: 4,
          label: '硕士'
        },
        {
          value: 5,
          label: '博士'
        },
        {
          value: 6,
          label: 'MBA/EMBA'
        }
      ],
      fileUrl: '',
      hjCityList: [
        {
          label: '北京',
          value: '北京'
        },
        {
          label: '上海',
          value: '上海'
        },
        {
          label: '天津',
          value: '天津'
        },
        {
          label: '重庆',
          value: '重庆'
        },
        {
          value: '河北',
          label: '河北',
          children: [
            {
              label: '石家庄',
              value: '石家庄'
            },
            {
              label: '保定',
              value: '保定'
            },
            {
              label: '张家口',
              value: '张家口'
            },
            {
              label: '承德',
              value: '承德'
            },
            {
              label: '沧州',
              value: '沧州'
            },
            {
              label: '唐山',
              value: '唐山'
            },
            {
              label: '廊坊',
              value: '廊坊'
            },
            {
              label: '衡水',
              value: '衡水'
            },
            {
              label: '秦皇岛',
              value: '秦皇岛'
            },
            {
              label: '邯郸',
              value: '邯郸'
            },
            {
              label: '邢台',
              value: '邢台'
            }
          ]
        },
        {
          value: '山西',
          label: '山西',
          children: [
            {
              label: '太原',
              value: '太原'
            },
            {
              label: '阳泉',
              value: '阳泉'
            },
            {
              label: '长治',
              value: '长治'
            },
            {
              label: '晋城',
              value: '晋城'
            },
            {
              label: '朔州',
              value: '朔州'
            },
            {
              label: '晋中',
              value: '晋中'
            },
            {
              label: '运城',
              value: '运城'
            },
            {
              label: '忻州',
              value: '忻州'
            },
            {
              label: '临汾',
              value: '临汾'
            },
            {
              label: '吕梁',
              value: '吕梁'
            },
            {
              label: '大同',
              value: '大同'
            }
          ]
        },
        {
          value: '辽宁',
          label: '辽宁',
          children: [
            {
              label: '大连',
              value: '大连'
            },
            {
              label: '沈阳',
              value: '沈阳'
            },
            {
              label: '抚顺',
              value: '抚顺'
            },
            {
              label: '本溪',
              value: '本溪'
            },
            {
              label: '丹东',
              value: '丹东'
            },
            {
              label: '锦州',
              value: '锦州'
            },
            {
              label: '营口',
              value: '营口'
            },
            {
              label: '阜新',
              value: '阜新'
            },
            {
              label: '辽阳',
              value: '辽阳'
            },
            {
              label: '盘锦',
              value: '盘锦'
            },
            {
              label: '铁岭',
              value: '铁岭'
            },
            {
              label: '朝阳',
              value: '朝阳'
            },
            {
              label: '葫芦岛',
              value: '葫芦岛'
            },
            {
              label: '鞍山',
              value: '鞍山'
            }
          ]
        },
        {
          value: '吉林',
          label: '吉林',
          children: [
            {
              label: '长春',
              value: '长春'
            },
            {
              label: '白山',
              value: '白山'
            },
            {
              label: '松原',
              value: '松原'
            },
            {
              label: '白城',
              value: '白城'
            },
            {
              label: '延边',
              value: '延边'
            },
            {
              label: '吉林市',
              value: '吉林市'
            },
            {
              label: '四平',
              value: '四平'
            },
            {
              label: '辽源',
              value: '辽源'
            },
            {
              label: '通化',
              value: '通化'
            }
          ]
        },
        {
          value: '黑龙江',
          label: '黑龙江',
          children: [
            {
              label: '哈尔滨',
              value: '哈尔滨'
            },
            {
              label: '佳木斯',
              value: '佳木斯'
            },
            {
              label: '七台河',
              value: '七台河'
            },
            {
              label: '牡丹江',
              value: '牡丹江'
            },
            {
              label: '黑河',
              value: '黑河'
            },
            {
              label: '绥化',
              value: '绥化'
            },
            {
              label: '大兴安岭',
              value: '大兴安岭'
            },
            {
              label: '齐齐哈尔',
              value: '齐齐哈尔'
            },
            {
              label: '鸡西',
              value: '鸡西'
            },
            {
              label: '鹤岗',
              value: '鹤岗'
            },
            {
              label: '双鸭山',
              value: '双鸭山'
            },
            {
              label: '大庆',
              value: '大庆'
            },
            {
              label: '伊春',
              value: '伊春'
            }
          ]
        },
        {
          value: '江苏',
          label: '江苏',
          children: [
            {
              label: '苏州',
              value: '苏州'
            },
            {
              label: '南京',
              value: '南京'
            },
            {
              label: '淮安',
              value: '淮安'
            },
            {
              label: '盐城',
              value: '盐城'
            },
            {
              label: '扬州',
              value: '扬州'
            },
            {
              label: '镇江',
              value: '镇江'
            },
            {
              label: '泰州',
              value: '泰州'
            },
            {
              label: '宿迁',
              value: '宿迁'
            },
            {
              label: '无锡',
              value: '无锡'
            },
            {
              label: '徐州',
              value: '徐州'
            },
            {
              label: '常州',
              value: '常州'
            },
            {
              label: '南通',
              value: '南通'
            },
            {
              label: '连云港',
              value: '连云港'
            }
          ]
        },
        {
          value: '浙江',
          label: '浙江',
          children: [
            {
              label: '杭州',
              value: '杭州'
            },
            {
              label: '台州',
              value: '台州'
            },
            {
              label: '丽水',
              value: '丽水'
            },
            {
              label: '宁波',
              value: '宁波'
            },
            {
              label: '温州',
              value: '温州'
            },
            {
              label: '嘉兴',
              value: '嘉兴'
            },
            {
              label: '湖州',
              value: '湖州'
            },
            {
              label: '绍兴',
              value: '绍兴'
            },
            {
              label: '金华',
              value: '金华'
            },
            {
              label: '衢州',
              value: '衢州'
            },
            {
              label: '舟山',
              value: '舟山'
            }
          ]
        },
        {
          value: '福建',
          label: '福建',
          children: [
            {
              label: '福州',
              value: '福州'
            },
            {
              label: '厦门',
              value: '厦门'
            },
            {
              label: '莆田',
              value: '莆田'
            },
            {
              label: '三明',
              value: '三明'
            },
            {
              label: '泉州',
              value: '泉州'
            },
            {
              label: '漳州',
              value: '漳州'
            },
            {
              label: '南平',
              value: '南平'
            },
            {
              label: '龙岩',
              value: '龙岩'
            },
            {
              label: '宁德',
              value: '宁德'
            }
          ]
        },
        {
          value: '江西',
          label: '江西',
          children: [
            {
              label: '南昌',
              value: '南昌'
            },
            {
              label: '萍乡',
              value: '萍乡'
            },
            {
              label: '九江',
              value: '九江'
            },
            {
              label: '新余',
              value: '新余'
            },
            {
              label: '鹰潭',
              value: '鹰潭'
            },
            {
              label: '赣州',
              value: '赣州'
            },
            {
              label: '吉安',
              value: '吉安'
            },
            {
              label: '宜春',
              value: '宜春'
            },
            {
              label: '抚州',
              value: '抚州'
            },
            {
              label: '上饶',
              value: '上饶'
            },
            {
              label: '景德镇',
              value: '景德镇'
            }
          ]
        },
        {
          value: '山东',
          label: '山东',
          children: [
            {
              label: '济南',
              value: '济南'
            },
            {
              label: '枣庄',
              value: '枣庄'
            },
            {
              label: '东营',
              value: '东营'
            },
            {
              label: '烟台',
              value: '烟台'
            },
            {
              label: '潍坊',
              value: '潍坊'
            },
            {
              label: '济宁',
              value: '济宁'
            },
            {
              label: '泰安',
              value: '泰安'
            },
            {
              label: '威海',
              value: '威海'
            },
            {
              label: '日照',
              value: '日照'
            },
            {
              label: '临沂',
              value: '临沂'
            },
            {
              label: '德州',
              value: '德州'
            },
            {
              label: '聊城',
              value: '聊城'
            },
            {
              label: '滨州',
              value: '滨州'
            },
            {
              label: '青岛',
              value: '青岛'
            },
            {
              label: '菏泽',
              value: '菏泽'
            },
            {
              label: '淄博',
              value: '淄博'
            }
          ]
        },
        {
          value: '河南',
          label: '河南',
          children: [
            {
              label: '郑州',
              value: '郑州'
            },
            {
              label: '商丘',
              value: '商丘'
            },
            {
              label: '开封',
              value: '开封'
            },
            {
              label: '信阳',
              value: '信阳'
            },
            {
              label: '洛阳',
              value: '洛阳'
            },
            {
              label: '周口',
              value: '周口'
            },
            {
              label: '驻马店',
              value: '驻马店'
            },
            {
              label: '平顶山',
              value: '平顶山'
            },
            {
              label: '济源',
              value: '济源'
            },
            {
              label: '安阳',
              value: '安阳'
            },
            {
              label: '鹤壁',
              value: '鹤壁'
            },
            {
              label: '新乡',
              value: '新乡'
            },
            {
              label: '焦作',
              value: '焦作'
            },
            {
              label: '濮阳',
              value: '濮阳'
            },
            {
              label: '许昌',
              value: '许昌'
            },
            {
              label: '漯河',
              value: '漯河'
            },
            {
              label: '三门峡',
              value: '三门峡'
            },
            {
              label: '南阳',
              value: '南阳'
            }
          ]
        },
        {
          value: '湖北',
          label: '湖北',
          children: [
            {
              label: '武汉',
              value: '武汉'
            },
            {
              label: '黄冈',
              value: '黄冈'
            },
            {
              label: '咸宁',
              value: '咸宁'
            },
            {
              label: '随州',
              value: '随州'
            },
            {
              label: '恩施州',
              value: '恩施州'
            },
            {
              label: '仙桃',
              value: '仙桃'
            },
            {
              label: '潜江',
              value: '潜江'
            },
            {
              label: '天门',
              value: '天门'
            },
            {
              label: '神农架',
              value: '神农架'
            },
            {
              label: '黄石',
              value: '黄石'
            },
            {
              label: '十堰',
              value: '十堰'
            },
            {
              label: '宜昌',
              value: '宜昌'
            },
            {
              label: '襄阳',
              value: '襄阳'
            },
            {
              label: '鄂州',
              value: '鄂州'
            },
            {
              label: '荆门',
              value: '荆门'
            },
            {
              label: '孝感',
              value: '孝感'
            },
            {
              label: '荆州',
              value: '荆州'
            }
          ]
        },
        {
          value: '湖南',
          label: '湖南',
          children: [
            {
              label: '长沙',
              value: '长沙'
            },
            {
              label: '永州',
              value: '永州'
            },
            {
              label: '怀化',
              value: '怀化'
            },
            {
              label: '娄底',
              value: '娄底'
            },
            {
              label: '湘西',
              value: '湘西'
            },
            {
              label: '株洲',
              value: '株洲'
            },
            {
              label: '湘潭',
              value: '湘潭'
            },
            {
              label: '衡阳',
              value: '衡阳'
            },
            {
              label: '邵阳',
              value: '邵阳'
            },
            {
              label: '岳阳',
              value: '岳阳'
            },
            {
              label: '常德',
              value: '常德'
            },
            {
              label: '张家界',
              value: '张家界'
            },
            {
              label: '益阳',
              value: '益阳'
            },
            {
              label: '郴州',
              value: '郴州'
            }
          ]
        },
        {
          value: '广东',
          label: '广东',
          children: [
            {
              label: '广州',
              value: '广州'
            },
            {
              label: '深圳',
              value: '深圳'
            },
            {
              label: '惠州',
              value: '惠州'
            },
            {
              label: '梅州',
              value: '梅州'
            },
            {
              label: '汕尾',
              value: '汕尾'
            },
            {
              label: '河源',
              value: '河源'
            },
            {
              label: '阳江',
              value: '阳江'
            },
            {
              label: '清远',
              value: '清远'
            },
            {
              label: '东莞',
              value: '东莞'
            },
            {
              label: '韶关',
              value: '韶关'
            },
            {
              label: '中山',
              value: '中山'
            },
            {
              label: '珠海',
              value: '珠海'
            },
            {
              label: '潮州',
              value: '潮州'
            },
            {
              label: '揭阳',
              value: '揭阳'
            },
            {
              label: '汕头',
              value: '汕头'
            },
            {
              label: '云浮',
              value: '云浮'
            },
            {
              label: '佛山',
              value: '佛山'
            },
            {
              label: '江门',
              value: '江门'
            },
            {
              label: '湛江',
              value: '湛江'
            },
            {
              label: '茂名',
              value: '茂名'
            },
            {
              label: '肇庆',
              value: '肇庆'
            }
          ]
        },
        {
          value: '广西',
          label: '广西',
          children: [
            {
              label: '梧州',
              value: '梧州'
            },
            {
              label: '北海',
              value: '北海'
            },
            {
              label: '防城港',
              value: '防城港'
            },
            {
              label: '钦州',
              value: '钦州'
            },
            {
              label: '贵港',
              value: '贵港'
            },
            {
              label: '玉林',
              value: '玉林'
            },
            {
              label: '百色',
              value: '百色'
            },
            {
              label: '贺州',
              value: '贺州'
            },
            {
              label: '河池',
              value: '河池'
            },
            {
              label: '来宾',
              value: '来宾'
            },
            {
              label: '崇左',
              value: '崇左'
            },
            {
              label: '南宁',
              value: '南宁'
            },
            {
              label: '柳州',
              value: '柳州'
            },
            {
              label: '桂林',
              value: '桂林'
            }
          ]
        },
        {
          value: '海南',
          label: '海南',
          children: [
            {
              label: '海口',
              value: '海口'
            },
            {
              label: '三亚',
              value: '三亚'
            },
            {
              label: '三沙',
              value: '三沙'
            },
            {
              label: '儋州',
              value: '儋州'
            },
            {
              label: '五指山',
              value: '五指山'
            },
            {
              label: '琼海',
              value: '琼海'
            },
            {
              label: '文昌',
              value: '文昌'
            },
            {
              label: '万宁',
              value: '万宁'
            },
            {
              label: '东方',
              value: '东方'
            },
            {
              label: '定安县',
              value: '定安县'
            },
            {
              label: '屯昌县',
              value: '屯昌县'
            },
            {
              label: '澄迈县',
              value: '澄迈县'
            },
            {
              label: '临高县',
              value: '临高县'
            },
            {
              label: '白沙县',
              value: '白沙县'
            },
            {
              label: '昌江县',
              value: '昌江县'
            },
            {
              label: '乐东县',
              value: '乐东县'
            },
            {
              label: '陵水县',
              value: '陵水县'
            },
            {
              label: '保亭县',
              value: '保亭县'
            },
            {
              label: '琼中县',
              value: '琼中县'
            }
          ]
        },
        {
          value: '四川',
          label: '四川',
          children: [
            {
              label: '成都',
              value: '成都'
            },
            {
              label: '南充',
              value: '南充'
            },
            {
              label: '眉山',
              value: '眉山'
            },
            {
              label: '宜宾',
              value: '宜宾'
            },
            {
              label: '广安',
              value: '广安'
            },
            {
              label: '达州',
              value: '达州'
            },
            {
              label: '雅安',
              value: '雅安'
            },
            {
              label: '巴中',
              value: '巴中'
            },
            {
              label: '自贡',
              value: '自贡'
            },
            {
              label: '资阳',
              value: '资阳'
            },
            {
              label: '阿坝',
              value: '阿坝'
            },
            {
              label: '攀枝花',
              value: '攀枝花'
            },
            {
              label: '泸州',
              value: '泸州'
            },
            {
              label: '甘孜',
              value: '甘孜'
            },
            {
              label: '德阳',
              value: '德阳'
            },
            {
              label: '绵阳',
              value: '绵阳'
            },
            {
              label: '凉山',
              value: '凉山'
            },
            {
              label: '广元',
              value: '广元'
            },
            {
              label: '遂宁',
              value: '遂宁'
            },
            {
              label: '内江',
              value: '内江'
            },
            {
              label: '乐山',
              value: '乐山'
            }
          ]
        },
        {
          value: '贵州',
          label: '贵州',
          children: [
            {
              label: '贵阳',
              value: '贵阳'
            },
            {
              label: '遵义',
              value: '遵义'
            },
            {
              label: '安顺',
              value: '安顺'
            },
            {
              label: '毕节',
              value: '毕节'
            },
            {
              label: '铜仁',
              value: '铜仁'
            },
            {
              label: '黔西南',
              value: '黔西南'
            },
            {
              label: '黔东南',
              value: '黔东南'
            },
            {
              label: '黔南',
              value: '黔南'
            },
            {
              label: '六盘水',
              value: '六盘水'
            }
          ]
        },
        {
          value: '云南',
          label: '云南',
          children: [
            {
              label: '昆明',
              value: '昆明'
            },
            {
              label: '丽江',
              value: '丽江'
            },
            {
              label: '普洱',
              value: '普洱'
            },
            {
              label: '临沧',
              value: '临沧'
            },
            {
              label: '楚雄州',
              value: '楚雄州'
            },
            {
              label: '红河',
              value: '红河'
            },
            {
              label: '文山州',
              value: '文山州'
            },
            {
              label: '西双版纳',
              value: '西双版纳'
            },
            {
              label: '大理州',
              value: '大理州'
            },
            {
              label: '德宏',
              value: '德宏'
            },
            {
              label: '怒江',
              value: '怒江'
            },
            {
              label: '迪庆',
              value: '迪庆'
            },
            {
              label: '曲靖',
              value: '曲靖'
            },
            {
              label: '玉溪',
              value: '玉溪'
            },
            {
              label: '保山',
              value: '保山'
            },
            {
              label: '昭通',
              value: '昭通'
            }
          ]
        },
        {
          value: '陕西',
          label: '陕西',
          children: [
            {
              label: '西安',
              value: '西安'
            },
            {
              label: '汉中',
              value: '汉中'
            },
            {
              label: '榆林',
              value: '榆林'
            },
            {
              label: '安康',
              value: '安康'
            },
            {
              label: '商洛',
              value: '商洛'
            },
            {
              label: '杨陵',
              value: '杨陵'
            },
            {
              label: '铜川',
              value: '铜川'
            },
            {
              label: '宝鸡',
              value: '宝鸡'
            },
            {
              label: '咸阳',
              value: '咸阳'
            },
            {
              label: '渭南',
              value: '渭南'
            },
            {
              label: '延安',
              value: '延安'
            }
          ]
        },
        {
          value: '甘肃',
          label: '甘肃',
          children: [
            {
              label: '兰州',
              value: '兰州'
            },
            {
              label: '临夏',
              value: '临夏'
            },
            {
              label: '甘南',
              value: '甘南'
            },
            {
              label: '嘉峪关',
              value: '嘉峪关'
            },
            {
              label: '金昌',
              value: '金昌'
            },
            {
              label: '白银',
              value: '白银'
            },
            {
              label: '天水',
              value: '天水'
            },
            {
              label: '武威',
              value: '武威'
            },
            {
              label: '张掖',
              value: '张掖'
            },
            {
              label: '平凉',
              value: '平凉'
            },
            {
              label: '酒泉',
              value: '酒泉'
            },
            {
              label: '庆阳',
              value: '庆阳'
            },
            {
              label: '定西',
              value: '定西'
            },
            {
              label: '陇南',
              value: '陇南'
            }
          ]
        },
        {
          value: '青海',
          label: '青海',
          children: [
            {
              label: '西宁',
              value: '西宁'
            },
            {
              label: '海东',
              value: '海东'
            },
            {
              label: '海北',
              value: '海北'
            },
            {
              label: '黄南',
              value: '黄南'
            },
            {
              label: '海南州',
              value: '海南州'
            },
            {
              label: '果洛',
              value: '果洛'
            },
            {
              label: '玉树',
              value: '玉树'
            },
            {
              label: '海西',
              value: '海西'
            }
          ]
        },
        {
          value: '宁夏',
          label: '宁夏',
          children: [
            {
              label: '银川',
              value: '银川'
            },
            {
              label: '石嘴山',
              value: '石嘴山'
            },
            {
              label: '吴忠',
              value: '吴忠'
            },
            {
              label: '固原',
              value: '固原'
            },
            {
              label: '中卫',
              value: '中卫'
            }
          ]
        },
        {
          value: '新疆',
          label: '新疆',
          children: [
            {
              label: '博尔塔拉',
              value: '博尔塔拉'
            },
            {
              label: '巴音郭楞',
              value: '巴音郭楞'
            },
            {
              label: '阿克苏',
              value: '阿克苏'
            },
            {
              label: '克州',
              value: '克州'
            },
            {
              label: '喀什',
              value: '喀什'
            },
            {
              label: '和田',
              value: '和田'
            },
            {
              label: '伊犁',
              value: '伊犁'
            },
            {
              label: '塔城',
              value: '塔城'
            },
            {
              label: '阿勒泰',
              value: '阿勒泰'
            },
            {
              label: '石河子',
              value: '石河子'
            },
            {
              label: '阿拉尔',
              value: '阿拉尔'
            },
            {
              label: '图木舒克',
              value: '图木舒克'
            },
            {
              label: '五家渠',
              value: '五家渠'
            },
            {
              label: '北屯',
              value: '北屯'
            },
            {
              label: '铁门关',
              value: '铁门关'
            },
            {
              label: '双河',
              value: '双河'
            },
            {
              label: '可克达拉',
              value: '可克达拉'
            },
            {
              label: '昆玉',
              value: '昆玉'
            },
            {
              label: '乌鲁木齐',
              value: '乌鲁木齐'
            },
            {
              label: '克拉玛依',
              value: '克拉玛依'
            },
            {
              label: '吐鲁番',
              value: '吐鲁番'
            },
            {
              label: '哈密',
              value: '哈密'
            },
            {
              label: '昌吉',
              value: '昌吉'
            }
          ]
        },
        {
          value: '内蒙古',
          label: '内蒙古',
          children: [
            {
              label: '乌海',
              value: '乌海'
            },
            {
              label: '赤峰',
              value: '赤峰'
            },
            {
              label: '通辽',
              value: '通辽'
            },
            {
              label: '鄂尔多斯',
              value: '鄂尔多斯'
            },
            {
              label: '呼伦贝尔',
              value: '呼伦贝尔'
            },
            {
              label: '巴彦淖尔',
              value: '巴彦淖尔'
            },
            {
              label: '乌兰察布',
              value: '乌兰察布'
            },
            {
              label: '兴安盟',
              value: '兴安盟'
            },
            {
              label: '锡盟',
              value: '锡盟'
            },
            {
              label: '阿拉善盟',
              value: '阿拉善盟'
            },
            {
              label: '呼和浩特',
              value: '呼和浩特'
            },
            {
              label: '包头',
              value: '包头'
            }
          ]
        }
      ],
      workYearList: [
        { label: '1年', value: '1' },
        { label: '2年', value: '2' },
        { label: '3年', value: '3' },
        { label: '4年', value: '4' },
        { label: '5年', value: '5' },
        { label: '6年', value: '6' },
        { label: '7年', value: '7' },
        { label: '8年', value: '8' },
        { label: '9年', value: '9' },
        { label: '10年', value: '10' },
        { label: '11年', value: '11' },
        { label: '12年', value: '12' },
        { label: '13年', value: '13' },
        { label: '14年', value: '14' },
        { label: '14年以上', value: '15' }
      ],
      educationList: [],
      workList: [],
      projectList: [],
      edus: [
        {
          value: '1',
          label: '大专以下'
        },
        {
          value: '2',
          label: '大专'
        },
        {
          value: '3',
          label: '本科'
        },
        {
          value: '4',
          label: '硕士'
        },
        {
          value: '5',
          label: '博士'
        },
        {
          value: '6',
          label: 'MBA/EMBA'
        }
      ]
    }
  },
  methods: {
    close() {
      this.$router.push('/home/search')
    },
    async recomReport() {
      this.post.birthYear = new Date(this.post.birthYear).getFullYear();
      for (const value of Object.values(this.post)) {
        if (value === '' || value === null || value === undefined) {
          this.$message.warning('基础信息完整度较低，建议完善更多信息');
          return;
        }
      }
      if (this.workList.length < 1) {
        this.$message.warning('工作经历完整度较低，建议完善更多信息');
        return;
      }
      if (this.educationList.length < 1) {
        this.$message.warning('教育经历完整度较低，建议完善更多信息');
        return;
      }
      const resumeData = {
        basicInfo: { ...this.post, ...this.post2 },
        works: this.workList,
        educations: this.educationList,
        projects: this.projectList,
      };
      var { data: res } = await AddResume({ data: resumeData, username: JSON.parse(sessionStorage.getItem("LoginInfo")).username });
      if (res.code === 200) {
        this.$message.success(res.message);
        this.$router.push('/resume?resumeID=CA' + (res.data + 100000000) + '&timestamp=' + Date.now())
      } else {
        this.$message.error(res.message);
      }
    },
    beforeUpload(file) {
      this.uploadedFileName = null
      this.uploadedFileUrl = null

      const fileType = file.type
      const fileExt = file.name.split('.').pop().toLowerCase()
      const isAllowedType = ['doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png'].includes(fileExt)
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isAllowedType) {
        this.$message.error('不支持的文件类型，仅支持 doc/docx/pdf/jpg/jpeg/png')
        return false
      }

      if (!isLt20M) {
        this.$message.error('文件大小不能超过 20MB')
        return false
      }

      this.resumeList = null
      this.loading = true
      this.uploadedFileName = '解析中...'
      return true
    },
    Textleft(text, key) {
      var index = text.indexOf(key)
      text = text.substring(0, index)
      return text
    },
    Textright(text, key) {
      var index = text.indexOf(key)
      text = text.substr(index + 1)
      return text
    },
    async handleSuccess(response, file, fileList) {
      if (response.code !== 200) {
        this.resumeList = null;
        this.$message.error(response.message);
      } else {
        this.loading = false;
        this.uploadedFileName = '解析成功！';
        this.fileUrl = response.path;
        this.resumeList = response.data;
        this.post.name = response.data.baseInfo.name;
        this.post.phone = response.data.baseInfo.phone;
        this.post2.email = response.data.baseInfo.email;
        this.post2.wechat = response.data.baseInfo.wechat;
        this.post.gender = response.data.baseInfo.gender === '女' ? 0 : 1;
        this.post.birthYear = String(response.data.baseInfo.age);
        this.post.workYear = response.data.baseInfo.workTime;
        this.post.wantCity = response.data.wantIntention.wantCity;
        this.post.wantSalary = response.data.wantIntention.wantSalary;
        this.post2.myself = response.data.myself;

        if (response.data.baseInfo.highEdu.indexOf('大专') !== -1) {
          this.post.highestEdu = 2
        } else if (response.data.baseInfo.highEdu.indexOf('本科') !== -1) {
          this.post.highestEdu = 3
        } else if (response.data.baseInfo.highEdu.indexOf('硕士') !== -1) {
          this.post.highestEdu = 4
        } else if (response.data.baseInfo.highEdu.indexOf('博士') !== -1) {
          this.post.highestEdu = 5
        } else {
          this.post.highestEdu = 1
        }
        if (response.data.edus.length >= 1) {
          response.data.edus.forEach(item => {
            const timeRange = item['time']
            var [eduStart, eduEnd] = '';
            if (timeRange.indexOf('-') !== -1) {
              [eduStart, eduEnd] = timeRange.split('-').map(part => {
                const trimmed = part.trim()
                return trimmed === '至今' ? '9999.0' : trimmed
              })
            }
            this.educationList.push({
              eduStart: eduStart || '',
              eduEnd: eduEnd || '',
              schoolName: item['school'],
              major: item['major'],
              edu: item['edu'],
              isUnified: item['isUnified'] === '' | item['isUnified'] === 'false' ? false : true,
            })
          });
        }
        if (response.data.works.length >= 1) {
          response.data.works.forEach(item => {
            const timeRange = item['time'];
            var [workStart, workEnd] = '';
            if (timeRange.indexOf('-') !== -1) {
              [workStart, workEnd] = timeRange.split('-').map(part => {
                const trimmed = part.trim()
                return trimmed === '至今' ? '9999.0' : trimmed
              })
            }
            this.workList.push({
              workStart: workStart || '',
              workEnd: workEnd || '',
              companyName: item['comName'],
              jobName: item['comJob'],
              workContent: Array.isArray(item['comResp']) ? item['comResp'].join('\n') : item['comResp'],
              workAchievement: Array.isArray(item['comPerf']) ? item['comPerf'].join('\n') : item['comPerf'],
              dimissionReason: item['reason'],
              department: '',
              reportPeople: '',
              underPeople: ''
            })
          })
        }
        if (response.data.projects.length >= 1) {
          response.data.projects.forEach(item => {
            const timeRange = item['time'];
            var [projectStart, projectEnd] = '';
            if (timeRange.indexOf('-') !== -1) {
              [projectStart, projectEnd] = timeRange.split('-').map(part => {
                const trimmed = part.trim()
                return trimmed === '至今' ? '9999.0' : trimmed
              })
            }
            this.projectList.push({
              projectStart: projectStart || '',
              projectEnd: projectEnd || '',
              projectName: item['projName'],
              projectDesc: Array.isArray(item['projDesc']) ? item['projDesc'].join('\n') : item['projDesc'],
              projectResponsibility: Array.isArray(item['projResp']) ? item['projResp'].join('\n') : item['projResp'],
              projectPerformance: Array.isArray(item['projPerf']) ? item['projPerf'].join('\n') : item['projPerf'],
            })
          })
        }
      }
    },
    handleError(err, file, fileList) {
      this.$message.error('上传过程中发生错误')
    },
    clearUploadedFile() {
      // 清除已上传的文件信息
      this.uploadedFileName = null
      this.uploadedFileUrl = null
      this.resumeList = null
    },
    YearDateChange(value) {
      const date = new Date(value)
      const nowYear = new Date()
      const age = nowYear.getFullYear() - date.getFullYear()
      this.birthYearNew = age + '岁(' + date.getFullYear() + ')'
    },
    DelEdu(index) {
      this.educationList.splice(index, 1)
    },
    DelWork(index) {
      this.workList.splice(index, 1)
    },
    DelPro(index) {
      this.projectList.splice(index, 1)
    },
    addProject() {
      this.projectList.push([
        {
          projectStart: '',
          projectEnd: '',
          projectEndNegotiable: false,
          projectName: '',
          projectDesc: '',
          projectResponsibility: '',
          projectPerformance: ''
        }
      ])
    },
    addWork() {
      this.workList.push([
        {
          workStart: '',
          workEnd: '',
          workEndNegotiable: false,
          companyName: '',
          jobName: '',
          department: '',
          reportPeople: '',
          underPeople: '',
          workContent: '',
          workAchievement: '',
          dimissionReason: ''
        }
      ])
    },
    addEducation() {
      this.educationList.push([
        {
          schoolName: '',
          eduStart: '',
          eduEnd: '',
          schoolEndNegotiable: false,
          edu: '',
          isUnified: '',
          major: ''
        }
      ])
    },
    setZJ(index, name) {
      if (name === 'project') {
        this.projectList[index].projectEnd = '9999.0'
      } else if (name === 'work') {
        this.workList[index].workEnd = '9999.0'
      } else if (name === 'education') {
        this.educationList[index].schoolEnd = '9999.0'
      }
    },
    changeEdu(i, name) {
      if (name === 'Strat') {
        const date = new Date(this.educationList[i].eduStart)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.educationList[i].eduStart = `${year}.${month}`
      } else {
        const date = new Date(this.educationList[i].eduEnd)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.educationList[i].eduEnd = `${year}.${month}`
      }
    },
    changeWork(i, name) {
      if (name === 'Strat') {
        const date = new Date(this.workList[i].workStart)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.workList[i].workStart = `${year}.${month}`
      } else {
        const date = new Date(this.workList[i].workEnd)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.workList[i].workEnd = `${year}.${month}`
      }
    },
    changeProject(i, name) {
      if (name === 'Strat') {
        const date = new Date(this.projectList[i].projectStart)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.projectList[i].projectStart = `${year}.${month}`
      } else {
        const date = new Date(this.projectList[i].projectEnd)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        this.projectList[i].projectEnd = `${year}.${month}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep input[aria-hidden='true'] {
  display: none !important;
}

* {
  font-size: 16px;
}

.pdf-show {
  display: flex;
  align-items: center;
  width: 100%;
  height: calc(100vh - 1px);

  .left {
    flex: 1;
    width: 50%;
    height: 100%;

    .left-header {
      height: 60px;
      background-color: #e9ecf1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .header-left {
        .el-link {
          font-size: 16px;
        }
      }

      .header-right {
        display: flex;
        align-items: center;
      }
    }

    .left-container {
      background-color: #fff;
      padding: 0 30px;
      height: calc(100% - 60px);
      overflow-y: auto;

      .uploadFile {
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .uploaded-file-info {
          margin-top: 10px;
        }
      }

      .report {
        padding-bottom: 30px;
        border-bottom: 1px solid #eaeaea;
        margin-bottom: 30px;

        .report-title {
          position: relative;
          color: #000;
          margin-top: 30px;
        }

        .education-title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add-education {
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .work-title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add-job {
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .project-title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .add-project {
            color: #409eff;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .report-title::before {
          position: absolute;
          content: ' ';
          left: -10px;
          width: 3px;
          height: 100%;
          background: #409eff;
        }

        .prompt {
          margin: 20px 0;
          text-align: center;
          letter-spacing: 2px;
        }

        .workProof {
          display: flex;
          margin-bottom: 20px;

          span {
            margin-bottom: 5px;
          }

          .des-input {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 20px;
          }
        }

        .company {
          border-top: 1px dashed #dcdfe6;
          padding: 20px 0;
          position: relative;

          .des-input {
            .company-name::before {
              position: absolute;
              content: '*';
              left: 20px;
              width: 3px;
              height: 100%;
              color: red;
            }
          }
        }

        .el-divider {
          .is-center {
            color: #409eff;
            font-size: 18px;
            font-weight: bold;
            letter-spacing: 3px;
          }
        }

        .Basic-information {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;

          .Basic-des-left {

            .des-input {
              display: flex;
              align-items: center;
              margin-bottom: 20px;
            }

            span {
              width: 99px;
              text-align: right;
              white-space: nowrap;
            }

            .el-input,
            .el-select,
            .el-cascader {
              width: 230px;
            }
          }

          .Basic-des-right {

            .left-des {
              display: flex;
              align-items: center;
              margin-bottom: 20px;

              span {
                width: 99px;
                text-align: right;
              }

              .el-input,
              .el-select,
              .el-cascader {
                width: 230px;
              }
            }
          }
        }

        .want-information {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .des-input {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .salary {
              ::v-deep .el-input {
                position: relative;
              }

              ::v-deep .el-input::before {
                content: 'K';
                position: absolute;
                color: #333;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }

          span {
            width: 99px;
            text-align: right;
            white-space: nowrap;
          }

          .el-input,
          .el-select,
          .el-cascader {
            width: 230px;
          }
        }

        .Situation-analysis {
          display: flex;
          flex-direction: column;
          margin-top: 20px;

          .des-input {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .Salary-status {
              margin-left: 20px;
            }
          }

          .interview {
            display: flex;
            align-content: center;
            justify-content: space-between;

            .des-input {
              display: flex;
              align-content: center;

              .el-select {
                width: 210px;
              }

              .el-input {
                width: 210px;
              }
            }
          }

          .Salary-structure {
            display: flex;
            flex-direction: column;

            span {
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          .Core-advantages {
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            span {
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          span {
            width: 66px;
            text-align: right;
            white-space: nowrap;
          }

          .el-input {
            width: 210px;
          }
        }

        .Education-experience:last-child {
          border-bottom: none;
          padding: 0;
        }

        .Education-experience {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #dcdfe6;
          padding: 10px 0 30px 0;

          .Education-des {
            display: flex;
            margin-top: 20px;

            .des-input {
              display: flex;
              align-items: center;

              .Education-date {
                display: flex;
                align-items: center;

                .Education-date-des {
                  display: flex;
                  align-items: center;

                  ::v-deep .el-date-editor {
                    width: 110px;

                    .el-input__prefix {
                      display: none;
                    }

                    .el-input__inner {
                      border: 0;
                      padding-left: 20px;
                      padding-right: 20px;
                    }
                  }
                }
              }

              .el-input,
              .el-select {
                width: 210px;
              }

              span {
                width: 66px;
                text-align: right;
                white-space: nowrap;
              }
            }
          }
        }

        .Work-experience:last-child {
          border-bottom: none;
          padding: 0;
        }

        .Work-experience {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #dcdfe6;
          padding: 10px 0 30px 0;
          border-bottom: 1px dashed #dcdfe6;

          .Work-vertical {
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            .des-input {
              display: flex;

              .el-input {
                width: 130px;
                margin-right: 20px;
              }
            }

            span {
              width: 66px;
              text-align: left;
              white-space: nowrap;
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          .Work-des {
            display: flex;
            margin-top: 20px;

            .Work-des-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }

            .des-input {
              display: flex;
              align-items: center;

              .el-input {
                width: 210px;
              }

              span {
                width: 66px;
                text-align: right;
                white-space: nowrap;
              }

              .Work-date {
                display: flex;
                align-items: center;

                .Work-date-des {
                  display: flex;
                  align-items: center;

                  ::v-deep .el-date-editor {
                    width: 110px;

                    .el-input__prefix {
                      display: none;
                    }

                    .el-input__inner {
                      border: 0;
                      padding-left: 20px;
                      padding-right: 20px;
                    }
                  }
                }
              }
            }
          }
        }

        .project-experience {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #dcdfe6;
          padding: 10px 0 30px 0;
          border-bottom: 1px dashed #dcdfe6;

          .project-vertical {
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            .des-input {
              display: flex;

              .el-input {
                width: 130px;
                margin-right: 20px;
              }
            }

            span {
              width: 66px;
              text-align: left;
              white-space: nowrap;
              margin-bottom: 15px;
            }

            .el-input {
              width: 100%;
            }
          }

          .project-des {
            display: flex;
            margin-top: 20px;

            .project-des-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }

            .des-input {
              display: flex;
              align-items: center;

              .el-input {
                width: 210px;
              }

              span {
                width: 66px;
                text-align: right;
                white-space: nowrap;
              }

              .project-date {
                display: flex;
                align-items: center;

                .project-date-des {
                  display: flex;
                  align-items: center;

                  ::v-deep .el-date-editor {
                    width: 110px;

                    .el-input__prefix {
                      display: none;
                    }

                    .el-input__inner {
                      border: 0;
                      padding-left: 20px;
                      padding-right: 20px;
                    }
                  }
                }
              }
            }
          }
        }

        .myself-information {
          padding-top: 10px;
        }
      }
    }
  }

  .right {
    width: 50%;
    height: 100%;
    background-color: #e9ecf1;

    .look {
      height: 100%;

      .look-show {
        height: 100%;
      }
    }
  }
}

.import::before {
  content: '*';
  color: #f56c6c;
  margin-right: 0.20833vw;
}
</style>